import { FC } from 'react';
import QRCode from 'qrcode.react';
import appConfig from '@frontend/env';
import { useTranslation } from '@frontend/i18n';
import { Text } from '@frontend/design-system';
import { containerStyle, qrCodeContainerStyle } from './mobile-preview.style';

interface MobilePreviewProps {
  templateId: string;
  locationId: string;
}

const MobilePreview: FC<MobilePreviewProps> = ({ templateId, locationId }) => {
  const { t } = useTranslation('forms');
  const { FORMS_EXPERIENCE_URL } = appConfig;
  const url = `${FORMS_EXPERIENCE_URL}/form-preview?templateId=${templateId}&companyId=${locationId}`;

  return (
    <div css={containerStyle}>
      <Text textAlign='center'>{t('Scan this QR code on your phone to preview this template')}</Text>
      <div>
        <QRCode value={url} size={200} css={qrCodeContainerStyle} />
      </div>
    </div>
  );
};

export default MobilePreview;
